export default "__VITE_ASSET__D7zzSlWw__"